// A canceled request rejects like every other axios failure (see the error interceptors in
// client/ and ionic/). Detected by error shape rather than axios.isCancel, because client-shared
// never imports axios — the apps inject it. Both fields are axios' public CanceledError surface,
// and `name` is what ionic's current-user.module.js already matches on.
const isCanceledRequestError = (error) =>
  error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED'

// Opts a caller out of the cancellation rejection, for loaders where "superseded" and "nothing to
// commit" are the same outcome — it keeps the established shape:
//
//   const list = await ignoreCanceledRequest(getThings({ signal, … }))
//   if (list) { commit(…) }
//
// Do NOT use it where those two outcomes differ. A caller that reports on an empty result, or that
// has to know its request was superseded, must inspect the rejection itself the way company.js and
// the company modals do — otherwise a canceled request is silently indistinguishable from a
// successful one that returned nothing.
const ignoreCanceledRequest = async (request) => {
  try {
    return await request
  } catch (error) {
    if (isCanceledRequestError(error)) {
      return
    }

    throw error
  }
}

export default ignoreCanceledRequest
